<app-table-suivis
  *ngIf="contact$ | async as contact"
  [source]="suivis$ | async"
  (add)="onAdd($event, contact)"
  (update)="onUpdate($event, contact)"
  (delete)="onDelete($event, contact)"
></app-table-suivis>
